"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
var _jsxruntime = require("react/jsx-runtime");
var _icons = require("../../assets/icons");
var ErrorNotification = function(param) {
    var content = param.content;
    return /*#__PURE__*/ (0, _jsxruntime.jsxs)("p", {
        style: {
            border: "1px solid red",
            paddingTop: "-0.3rem",
            paddingLeft: "0.4rem",
            background: "rgb(212 42 84 / 26%)",
            borderRadius: "0.3rem",
            display: "flex",
            flexDirection: "row",
            padding: "0.3rem",
            margin: "0 1.3rem",
            marginBottom: "0.7rem"
        },
        children: [
            /*#__PURE__*/ (0, _jsxruntime.jsx)(_icons.AlertIcon, {
                style: {
                    width: "1rem",
                    height: "1rem"
                }
            }),
            " ",
            /*#__PURE__*/ (0, _jsxruntime.jsx)("span", {
                style: {
                    marginLeft: "0.5rem",
                    marginTop: "-0.3rem"
                },
                children: content
            })
        ]
    });
};
var _default = ErrorNotification;
